import { initializeDB } from '../config/db';
import { LIFT_TRUCK_PM_STORE, EQUIPMENT_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

/**
 * Lift Truck PM Inspection.
 *
 * Черновики живут в IndexedDB; отправленная форма из стора удаляется и дальше
 * существует только в Symfony — как у остальных форм планшета.
 *
 * Make / Model / Serial разбираются из Category прямо на планшете
 * (utils/equipmentIdentityParser.js); сюда — только запоминание правки техника.
 */
export const liftTruckPmService = {
    async submit(form) {
        const response = await axiosInstance.post('/lift-truck-pm/submit', form);
        return response.data;
    },

    /** Запомнить исправленные техником Make / Model / Serial для этой единицы. */
    async saveEquipmentIdentity(equipmentId, identity) {
        const response = await axiosInstance.patch(`/equipment/${equipmentId}/identity`, identity);
        if (response.data?.data) {
            await this.updateEquipmentInIndexedDB(response.data.data);
        }
        return response.data;
    },

    async updateEquipmentInIndexedDB(equipment) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(EQUIPMENT_STORE, 'readwrite');
            await tx.objectStore(EQUIPMENT_STORE).put(equipment);
            await tx.done;
        } catch (error) {
            // Локальная копия — удобство, а не источник правды: на сервере уже сохранено.
            console.error('Error updating equipment in IndexedDB:', error);
        }
    },

    async saveToIndexedDB(formData) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(LIFT_TRUCK_PM_STORE, 'readwrite');
            const store = tx.objectStore(LIFT_TRUCK_PM_STORE);

            const dataToSave = {
                ...formData,
                updatedAt: new Date().toISOString(),
            };

            if (!dataToSave.createdAt) {
                dataToSave.createdAt = new Date().toISOString();
            }

            await store.put(dataToSave);
            await tx.done;

            return dataToSave;
        } catch (error) {
            console.error('Error saving Lift Truck PM Inspection to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(LIFT_TRUCK_PM_STORE, 'readonly');
            const data = await tx.objectStore(LIFT_TRUCK_PM_STORE).get(uuid);
            await tx.done;
            return data;
        } catch (error) {
            console.error('Error reading Lift Truck PM Inspection from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction(LIFT_TRUCK_PM_STORE, 'readonly');
            const data = await tx.objectStore(LIFT_TRUCK_PM_STORE).getAll();
            await tx.done;
            return data || [];
        } catch (error) {
            console.error('Error reading Lift Truck PM Inspection list from IndexedDB:', error);
            return [];
        }
    },

    async deleteFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(LIFT_TRUCK_PM_STORE, 'readwrite');
            await tx.objectStore(LIFT_TRUCK_PM_STORE).delete(uuid);
            await tx.done;
        } catch (error) {
            console.error('Error deleting Lift Truck PM Inspection from IndexedDB:', error);
            throw error;
        }
    },
};

export default liftTruckPmService;
